import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import styles from './usos-icon-link.scss';

import { UsosIcon } from './usos-icon';

/**
 * An icon rendered as a link.
 *
 * The `href` property is forwarded to an anchor in the shadow root, and focus
 * is delegated to that anchor. Extending `UsosIcon` allows this component to
 * override the static `delegatesFocus` setting.
 */
@customElement('usos-icon-link')
export class UsosIconLink extends UsosIcon {
    static override shadowRootOptions = { ...LitElement.shadowRootOptions, delegatesFocus: true };

    static override styles = [styles, ...super.styles];


    // section: properties

    /**
     * href attribute to be forwarded to <a> element in Shadow Root
     */
    @property() href = '';


    // section: lifecycle

    override render() {
        return html`
            <a href=${this.href}>
                ${super.render()}
            </a>
        `;
    }

    override updated() {
        this.tabIndex = 0;
    }

}

declare global {
    interface HTMLElementTagNameMap {
        'usos-icon-link': UsosIconLink;
    }
}
